import {
    mean,
    median,
    sampleCorrelation,
    standardDeviation,
} from "simple-statistics"

export const NUMERIC_INSIGHTS = "Numeric Insights"
export const CHART_INSIGHTS = "Chart Insights"

export const INITIAL_MESSAGES = [
    {
        text: "Score Report Hi, I am Orby, your personal report maker of your vision. You can view your progress through numeric insights or chart insights. Which one would you like to choose?",
        sender: "bot",
        options: ["Numeric Insights", "Chart Insights"],
    },
]

export const NUMERIC_INSIGHTS_OPTIONS = [
    "Level",
    "Time",
    "Average Accuracy",
    "Average Precision",
    "Typical Accuracy",
    "Typical Precision",
    "Consistency",
    "Go Back",
]

export const CHART_INSIGHTS_OPTIONS = [
    "Correctness rate",
    "Accuracy and Precision",
    "Precision",
    "Level",
    "Go Back",
]

export const getAverageTimeToLevelUp = (scoreHistory, profileDetails, path) => {
    const dates = scoreHistory?.map((data) => data.created_at)
    const levels = scoreHistory?.map(
        (data) => data.level ?? profileDetails?.exercises?.[path]?.level
    )
    const totalLevels = levels.length
    const avgTimeToLevelUp =
        (new Date(dates[dates.length - 1]) - new Date(dates[0])) /
        (totalLevels - 1) /
        (1000 * 60 * 60 * 24)

    return avgTimeToLevelUp.toFixed(2)
}

export const getAccuracies = (selectedExercise) => {
    if (selectedExercise) {
        const dataWithAccuracy = selectedExercise?.scoreHistory?.map(
            (data) => ({
                accuracy: (data.correct / data.total) * 100,
            })
        )

        const accuracies = dataWithAccuracy?.map((data) =>
            isNaN(data.accuracy) ? 0 : data.accuracy
        )
        const meanAccuracy = mean(accuracies).toFixed(2)
        const medianAccuracy = median(accuracies).toFixed(2)
        const stdDeviationAccuracy = standardDeviation(accuracies).toFixed(2)

        return {
            meanAccuracy,
            medianAccuracy,
            stdDeviationAccuracy,
        }
    }
}

export const getPrecision = (scoreHistory) => {
    if (scoreHistory) {
        const dataWithPrecision = scoreHistory
            ?.map((data) => {
                const precision = data?.precision?.$numberDecimal
                if (precision) {
                    return Number(precision) // Convert to number
                } else {
                    return 0
                }
            })
            .map(Number)
        const averagePrecision = mean(dataWithPrecision).toFixed(2)
        const medianPrecision = median(dataWithPrecision).toFixed(2)
        return {
            averagePrecision,
            medianPrecision,
        }
    }
}

export const getCorrectIncorrectCorelation = (scoreHistory) => {
    if (scoreHistory) {
        const correctAttempts = scoreHistory.map((data) => data.correct)
        const incorrectAttempts = scoreHistory.map((data) => data.incorrect)

        const correlationCorrectIncorrect = sampleCorrelation(
            correctAttempts,
            incorrectAttempts
        )

        return correlationCorrectIncorrect
    }
}
